export default __webpack_public_path__ + "static/media/flag-status.b1e55357.svg";